<template>
  <div class="clearfix">
    <template v-if="multiple">
     <a-upload
      :action="uploadImgUrl"
      :listType="type == 'image' ? 'picture-card' : 'picture'"
      :file-list="fileList"
       :showUploadList="showUploadList"
       :multiple="multiple"
       :headers="headers"
      @change="change"
    >
      <div v-if="fileList.length < count">
        <a-icon :type="loading ? 'loading' : 'plus'" />
        <div class="ant-upload-text">上传附件</div>
      </div>
    </a-upload>
    </template>
    <template v-if="!multiple">
      <a-upload
        :action="uploadImgUrl"
        :listType="type == 'image' ? 'picture-card' : 'picture'"
        :showUploadList="showUploadList"
        :headers="headers"
        :beforeUpload="beforeUpload"
        @change="handleChange"
      >
        <img
          style="width: 86px; height: 86px; object-fit: cover"
          v-if="value && type == 'image'"
          :src="value"
          alt="avatar"
        />
        <div v-if="type == 'file'">
          <a-button> <a-icon type="upload" /> 上传附件 </a-button>
        </div>
        <template v-if="!multiple">
          <div v-if="value == '' || value == null">
            <span v-if="type == 'image'">
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <!-- <div class="ant-upload-text">上传</div> -->
              <div class="ant-upload-text">上传附件</div>
            </span>
          </div>
        </template>
      </a-upload>
    </template>
    
    <span v-if="value && type == 'file'">
      <br />
      <a :href="value" target="_blank">{{ value }}</a>
    </span>
  </div>
</template>

<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'ImageUpload',
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'image',
    },
    count: {
      type: Number,
      default: 1,
    },
    multiple:{
      type:Boolean,
      default:false
    },
    showUploadList:{
      type:Boolean,
      default:false
    },
    // 默认文件列表
    defaultFileList:{
      type:Array,
      default:()=>[]
    }
  },
  components: {},
  data() {
    return {
      loading: false,
      open: false,
      fileList:[],
      uploadImgUrl: process.env.VUE_APP_BASE_URL + '/system/oss/upload',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        // Authorization: storage.get(ACCESS_TOKEN),
      },
    }
  },
  watch:{
    defaultFileList:{
      handler(val){
        this.fileList = [...this.defaultFileList]
      },
      deep:true,
      immediate:true
    }
  },
  mounted() {},
  methods: {
    async handleChange(info) {
      console.log(info, 'infp')
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        if (info.file.response.code !== 200) {
          this.$message.error('上传失败' + info.file.response.msg)
          this.loading = false
          return
        }
        this.loading = false
        // console.log(info,'2222')
        
        this.$emit('input', info.file.response.data.url)
        this.$emit('ossId', info.file.response.data.ossId)
      }
      
    },
    change(info){
      console.log(info,'000000')
       
      this.fileList = [...info.fileList]
      this.$emit('changeList',this.fileList)
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf'
      if (!isJpgOrPng) {
        this.$message.error('您可以上传jpeg/jpg/png/dpf!')
      }
      // const isLt2M = file.size / 1024 / 1024 < 2
      // if (!isLt2M) {
      //   this.$message.error('Image must smaller than 2MB!')
      // }
      return isJpgOrPng
      // && isLt2M
    },
  },
}
</script>
<style lang="less" scoped>
img {
  width: 240px;
  height: 160px;
}
</style>
